/*
 * Create a cache object based on MapCache or StorageCache, mostly for fetch-utils.
 *
 *  Example:
 *      import Cache from '@corefact/toolchain/cache';
 *      let c = new Cache(10, 'local', 'api');
 */
import MapCache from './MapCache';
import StorageCache from './StorageCache';
import IndexedDBCache from './IndexedDBCache';

export default class Cache {
    constructor(limit = 10, type = 'map', db = 'db') {
        switch (type) {
            case 'local':
                return new StorageCache(limit, localStorage, db, type);
            case 'session':
                return new StorageCache(limit, sessionStorage, db, type);
            case 'indexdb':
                return new IndexedDBCache(limit, undefined, db, type);
            case 'map':
            default:
                return new MapCache(limit);
        }
    }
}

export function isCacheType(type = null) {
    return [
        'local',
        'session',
        'indexdb',
        'map',
    ].includes(type);
}
